import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { CAROUSEL_EPISODES_LIMIT } from '@/constants';
import {
  BookmarkedEpisodesCarousel,
  CategoriesCarousel,
  CategoryEpisodesCarousel,
  FeaturedEpisodesCarousel,
  FeaturedLearningPathsCarousel,
  FreeTrialPrompt,
  NewGeneralEpisodesCarousel,
  NewTechnicalEpisodesCarousel,
  OrganizationPlaylistCarousel,
  RecommendedEpisodesCarousel,
  SpecialFeaturesCarousel,
  TrendingEpisodesCarousel,
  YourFirstListenCarousel,
} from '@/containers';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectIsAdminUser,
  selectSessionUserId,
  selectUserCompliance,
  useFetchLibraryCategoriesQuery,
  useFetchLibraryEpisodesQuery,
} from '@/store';

export const Discover = () => {
  const userId = useSelector(selectSessionUserId);
  const isAdminUser = useSelector(selectIsAdminUser);
  const compliance = useSelector(selectUserCompliance);

  const { data: libraryCategories } = useFetchLibraryCategoriesQuery();
  const { data: specialFeatureEpisodes } = useFetchLibraryEpisodesQuery(
    {
      librarySlugs: libraryCategories?.ids ?? [],
      facets: { format: ['special-feature'] },
      params: { limit: CAROUSEL_EPISODES_LIMIT },
      compliance,
    },
    { skip: !libraryCategories },
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <YourFirstListenCarousel />
      <FeaturedEpisodesCarousel />
      <CategoriesCarousel />
      {isAdminUser && <OrganizationPlaylistCarousel />}
      <RecommendedEpisodesCarousel />
      <TrendingEpisodesCarousel />
      <NewGeneralEpisodesCarousel />
      <NewTechnicalEpisodesCarousel />
      <SpecialFeaturesCarousel episodes={specialFeatureEpisodes ?? []} />
      <BookmarkedEpisodesCarousel />
      {!isAdminUser && <OrganizationPlaylistCarousel />}
      <FeaturedLearningPathsCarousel />
      {!userId && (
        <FreeTrialPrompt referrer={{ page: EVENT_CONSTANTS.PAGE.DISCOVER }} />
      )}
      {Object.values(libraryCategories?.entities || {}).map(category => (
        <CategoryEpisodesCarousel key={category.name} category={category} />
      ))}
    </Box>
  );
};
